import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export class TranslateExtension {
  constructor(private _translate: TranslateService) {}
  prePopulate(field: FormlyFieldConfig) {
    const to = field.templateOptions || {};
    if (!to.translate || to._translated) {
      return;
    }

    to._translated = true;
    field.expressionProperties = {
      ...(field.expressionProperties || {}),
      'templateOptions.label': this._translate.stream(to.label)
    };
  }
}

export const registerTranslateExtension = (translate: TranslateService) => ({
  validationMessages: [
    {
      name: 'required',
      // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
      message() {
        return translate.stream('form-validation.required');
      }
    }
  ],
  extensions: [
    {
      name: 'translate',
      extension: new TranslateExtension(translate)
    }
  ]
});
